import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lottery-page',
  templateUrl: './lottery-page.component.html',
  styleUrls: ['./lottery-page.component.css']
})
export class LotteryPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
